import client from "../Client/HttpClient";
import { IIndividualEnrollmentModel } from "@/interfaces/modules";
const ApiPath = "Enrollments";

export default {
    GetEnrollments: (): Promise<IIndividualEnrollmentModel[]> => client.get(`${ApiPath}`),
    GetEnrollmentsByGroupYear: (data: any): Promise<IIndividualEnrollmentModel[]> => client.get(`${ApiPath}/byGroupYear/${data.GroupId}/${data.AcademicYearId}`),
    GetEnrollmentById: (data: any): Promise<IIndividualEnrollmentModel> => client.get(`${ApiPath}/${data.Id}`),
    GetByStudentLastEnrollment: (Id: any): Promise<IIndividualEnrollmentModel> => client.get(`${ApiPath}/byStudentLastEnrollment/${Id}`),
    PostEnrollment: (data: IIndividualEnrollmentModel): Promise<IIndividualEnrollmentModel> => client.post(`${ApiPath}`, data),
    GetPrintEnrollment: (Id: any): Promise<any> => client.get(`${ApiPath}/GetPrintEnrollment/${Id}`),
};